export function indexOfLargest(input: number[]) {
	return input.indexOf(Math.max(...input));
}
